import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiScissors, FiPhone, FiMail, FiMapPin, FiFacebook, FiInstagram } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-gradient-to-br from-amber-400 to-rose-400 p-2 rounded-full">
                <SafeIcon icon={FiScissors} className="text-white text-xl" />
              </div>
              <div>
                <h3 className="font-playfair text-xl font-bold">Melissa's</h3>
                <p className="font-inter text-sm text-gray-300">Wonderful Hair Salon</p>
              </div>
            </div>
            <p className="font-inter text-gray-300 mb-6 max-w-md">
              Transform your look with our personalized beauty services. Where passion meets professionalism in every style.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://facebook.com" 
                className="bg-gray-700 p-2 rounded-full hover:bg-amber-600 transition-colors"
                aria-label="Facebook"
              >
                <SafeIcon icon={FiFacebook} className="text-white" />
              </a>
              <a 
                href="https://instagram.com" 
                className="bg-gray-700 p-2 rounded-full hover:bg-amber-600 transition-colors"
                aria-label="Instagram"
              >
                <SafeIcon icon={FiInstagram} className="text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-4">Quick Links</h4>
            <nav className="space-y-2">
              <Link to="/" className="block font-inter text-gray-300 hover:text-amber-400 transition-colors">
                Home
              </Link>
              <Link to="/about" className="block font-inter text-gray-300 hover:text-amber-400 transition-colors">
                About
              </Link>
              <Link to="/services" className="block font-inter text-gray-300 hover:text-amber-400 transition-colors">
                Services
              </Link>
              <Link to="/contact" className="block font-inter text-gray-300 hover:text-amber-400 transition-colors">
                Contact
              </Link>
              <Link to="/privacy" className="block font-inter text-gray-300 hover:text-amber-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="block font-inter text-gray-300 hover:text-amber-400 transition-colors">
                Terms & Conditions
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="text-amber-400" />
                <span className="font-inter text-gray-300 text-sm">
                  123 Beauty Street<br />Style City, XY 45678
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-amber-400" />
                <span className="font-inter text-gray-300 text-sm">(123) 456-7890</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="text-amber-400" />
                <span className="font-inter text-gray-300 text-sm">contact@melissashair.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="font-inter text-gray-400 text-sm">
            © 2024 Melissa's Wonderful Hair Salon. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;